<template>
  <div class="filters-box">
    <div class="filters" :class="{ opened }">
      <div class="filters_backdrop" @click="closeFilters"></div>
      <div class="filters__container">
        <div class="filters__inner">
          <div class="close" @click="closeFilters"><span class="fi-rr-cross"></span></div>
          <div class="loader" v-if="colorsLoading || brandsLoading || storagesLoading"><SmallLoader/></div>
          <div class="filter-name"><span class="fi-rr-settings-sliders"></span>Filtres</div>
          <div class="reset"><a href="" @click.prevent="resetFilters">Réinitialiser les filtres</a></div>
          <div class="search" v-if="false">
            <label><input type="text" name="search" placeholder="Chercher un modèle..." v-model="payload.search" @input="updateFilters"></label>
          </div>
          <div class="attributes">
            <Attribute name="Marques" type="brands" :multiple="true" :options="brandOptions" :selection="payload.brands" @update="updateProducts"/>
            <Attribute name="Couleurs" type="colors" :multiple="true" :options="colorOptions" :selection="payload.colors" @update="updateProducts"/>
            <Attribute name="Stockage" type="storages" :multiple="false" :options="storageOptions" :selection="payload.storage" @update="updateProducts"/>
          </div>
          <PriceRangeSelector :min="0" :max="2500" :start="payload.price.min" :end="payload.price.max" @update="updatePriceRange"/>
        </div>
        <div class="offer" v-if="promo">
          <div class="offer-inner">
            <img :src="promo" alt="Promotion Welcom">
          </div>
        </div>
      </div>
    </div>
    <div class="filters-button" :class="{ opened }">
      <a href="" @click.prevent="closeFilters">Voir les résultats</a>
    </div>
  </div>
</template>

<script>
import SmallLoader from './SmallLoader'
import Attribute from './Filters/Attribute'
import PriceRangeSelector from './Filters/PriceRangeSelector'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Filters',
  data () {
    return {
      payload: {
        search: '',
        brands: [],
        colors: [],
        storage: [],
        price: {
          min: 0,
          max: 2500
        }
      }
    }
  },
  mounted() {
    this.getBrands().then(() => {
      this.checkDefaultBrand()
    })
    this.getStorages()
    this.getColors()
    this.checkSearch()
    document.addEventListener( 'scroll', this.handleScroll );
  },
  methods: {
    ...mapActions('products', ['closeFilters']),
    ...mapActions('colors', ['getColors']),
    ...mapActions('brands', ['getBrands']),
    ...mapActions('storages', ['getStorages']),
    updateFilters () {
      this.$emit('update', this.payload)
    },
    resetFilters () {
      this.payload = {
        search: '',
        brands: [],
        colors: [],
        storage: [],
        price: {
          min: 0,
          max: 2500
        }
      }
      this.updateFilters()
    },
    updateProducts (value) {

      if(value.type === 'brands') this.payload.brands = value.selection
      if(value.type === 'colors') this.payload.colors = value.selection
      if(value.type === 'storages') this.payload.storages = value.selection

      this.updateFilters()
    },
    updatePriceRange (value) {

      this.payload.price.min = value.min
      this.payload.price.max = value.max

      this.updateFilters()
    },
    checkSearch () {
      let params = (new URL(document.location)).searchParams
      let search = params.get('search')
      let brands = params.get('brands')
      let colors = params.get('colors')
      let storage = params.get('storage')
      let priceMin = params.get('price-min')
      let priceMax = params.get('price-max')

      if(search) this.payload.search = search
      if(brands) this.payload.brands = brands.split(',')
      if(colors) this.payload.colors = colors.split(',')
      if(storage) this.payload.storage = storage.split(',')
      if(priceMin) this.payload.price.min = parseInt(priceMin)
      if(priceMax) this.payload.price.max = parseInt(priceMax)

      if(search || brands || colors || storage || priceMin || priceMax){
        this.updateFilters()
      }
    },
    handleScroll() {
      // Define selectors.
      let parent = document.querySelector('.filters-box');
      let child = parent.querySelector('.filters');
      let parentTop = parent.getBoundingClientRect().top || 0;
      let crossChildHeight = 0;
      if( child.clientHeight > parent.getBoundingClientRect().bottom ) {
        crossChildHeight = parent.getBoundingClientRect().bottom - child.clientHeight;
      }
      if( parseInt( crossChildHeight ) < 0 ) {
        parent.classList.remove( 'fixed' )
        parent.classList.add( 'absolute' )
      } else {
        parent.classList.remove( 'absolute' )
        if( parentTop <= crossChildHeight ) {
          parent.classList.add( 'fixed' )
        } else {
          parent.classList.remove( 'fixed' )
        }
      }
    },
    checkDefaultBrand () {
      return new Promise((resolve) => {
        const el = document.getElementById('welcom-products')
        const brand = el.getAttribute('data-brand')
        if(brand){
          this.payload.brands.push(brand)
          this.updateFilters()
        }
        resolve()
      })
    }
  },
  computed: {
    ...mapState({
      opened: state => state.products.filters,
      promo: state => state.products.promo,
      colors: state => state.colors.items,
      brands: state => state.brands.items,
      storages: state => state.storages.items,
      colorsLoading: state => state.colors.loading,
      brandsLoading: state => state.brands.loading,
      storagesLoading: state => state.storages.loading,
    }),
    colorOptions () {
      const colors = []

      this.colors.forEach((color) => {
        colors.push({
          name: color.name,
          value: color.id
        })
      })

      return colors
    },
    brandOptions () {
      const brands = []

      this.brands.forEach((brand) => {
        brands.push({
          name: brand.name,
          value: brand.id
        })
      })

      return brands
    },
    storageOptions () {
      const storages = []

      this.storages.forEach((storage) => {
        storages.push({
          name: storage.name,
          value: storage.id
        })
      })

      return storages
    }
  },
  components: {
    Attribute,
    SmallLoader,
    PriceRangeSelector
  }
}
</script>

<style lang="scss" scoped>
@import '../../../scss/tools/*';
@import '../../../scss/mixins/*';

.filters-button{
  display: none;
  padding: 20px;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: darken(#f9f9f9, 5%);
  width: calc(100% - 60px);
  z-index: 1000;
  @include transform(translateX(-100%) translateZ(0));
  @include transition();

  &.opened{
    @include transform(translateX(0) translateZ(0));
  }

  @include responsive(mobile){
    display: block;
  }

  a{
    display: block;
    width: 100%;
    height: 40px;
    line-height: 38px;
    color: $white;
    background-color: $primary;
    text-align: center;
    @include radius(20px);
  }
}

.filters-box{
  position: relative;

  &.fixed{
    .filters{
      position: fixed;
      top: 0;
      width: 300px;

      @include responsive(mobile){
        width: 100vw;
      }
    }
  }

  &.absolute{
    .filters{
      position: absolute;
      bottom: 0;
      width: 300px;

      @include responsive(mobile){
        position: fixed;
        bottom: initial;
        width: 100vw;
      }
    }
  }
}

.filters{
  width: 100%;
  background-color: #f9f9f9;
  padding-left: 30px;

  @include responsive(mobile) {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
    overflow: scroll;
    padding: 0;
    background-color: rgba($black, 0);
    @include transform(translateX(-100%) translateZ(0));
    @include transition();

    &.opened{
      @include transform(translateX(0) translateZ(0));

      .filters_backdrop{
        opacity: 1;
      }
    }
  }

  .filters_backdrop{
    display: none;
    @include transition();

    @include responsive(mobile){
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      top: 0;
      right: 0;
      z-index: -1;
      opacity: 0;
    }
  }

  .filters__container{
    @include responsive(mobile){
      background-color: #f9f9f9;
      padding: 0 20px;
      width: calc(100% - 60px);
      padding-top: 90px;
      padding-bottom: 60px;
      position: relative;
    }
  }

  .filters__inner{
    position: relative;

    .close{
      display: none;
      width: 40px;
      height: 40px;
      color: $black;
      background-color: darken($white, 10%);
      position: absolute;
      top: 10px;
      right: 10px;
      text-align: center;
      line-height: 40px;
      @include radius(100%);

      @include responsive(mobile) {
        display: block;
      }
    }

    .loader{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 100;
      background-color: rgba(#f9f9f9, 0.8);
      @include radius(10px);
    }
  }

  .filter-name{
    padding: 20px 20px 0 0;
    font-size: px2rem(14px);
    font-weight: $fontBold;

    span{
      font-size: 24px;
      vertical-align: middle;
      margin-right: 10px;
    }
  }

  .reset{
    padding: 20px 0 0 0;

    a{
      font-size: px2rem(13px);
      color: darken(white, 30%);
      text-decoration: underline;
    }
  }

  .search{
    padding: 20px 0;
    border-bottom: 1px solid darken($white, 10%);

    input{
      height: 40px;
      padding: 0 20px;
      font-family: $poppins;
      font-size: 13px;
      color: $black;
      outline: none;
      border: 1px solid #b2b2b2;
      @include transition();
      @include radius(20px);

      &:focus{
        border: 1px solid $primary;
      }
    }
  }

  .offer{
    padding: 20px 0 40px 0;

    .offer-inner{
      background-color: darken($white, 10%);
      overflow: hidden;
      height: 400px;
      color: $white;
      text-align: center;
      @include radius(5px);

      img{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}
</style>
